import { createRouter } from '@tanstack/react-router';
import { apolloClient } from './apollo';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
	routeTree,
	context: { apolloClient },
	defaultPreload: 'intent',
	defaultStaleTime: 5000,
	scrollRestoration: true,
	defaultViewTransition: true,
	defaultNotFoundComponent: () => <div>Page not found</div>,
});
